<template>
  <div class="headline-labels">
    <div class="headline-labels__item-wrapper">
      <div v-for="(label, index) in labels" :key="index" class="display-inline-flex headline-labels__item">
        <div class="headline-labels__label" :class="{ 'headline-labels__label--pill': pill, 'headline-labels__label--paid': paid && index === 0 }">
          <template v-if="label.href">
            <link-handler :href="label.href | navigationUrl(fakeDomainEnabled)">
              {{ label.title }}
            </link-handler>
          </template>
          <template v-else>
            {{ label.title }}
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { HeadlineLabel } from '@headlines/types/headline';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';

interface Props {
  labels: HeadlineLabel[];
  paid: boolean;
  pill: boolean;
}

// Define dummy filter if process is not defined
if (typeof process === 'undefined') {
  Vue.filter('navigationUrl', (url: string, fakeDomainEnabled: boolean) => {
    if (fakeDomainEnabled) {
      return url;
    }

    return url;
  });
}

interface $nuxtWindow extends Window {
  $nuxt: any;
}

interface Process {
  client: boolean;
  env: any;
}

declare let window: $nuxtWindow;
declare let process: Process;

export default Vue.extend<unknown, unknown, unknown, Props>({
  name: 'HeadlineLabels',
  components: {
    LinkHandler,
  },
  props: {
    labels: {
      type: Array,
      required: true,
    },
    paid: {
      type: Boolean,
      default: false,
      required: false,
    },
    pill: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    fakeDomainEnabled() {
      return typeof process !== 'undefined'
        ? process && process.client
          ? window.$nuxt && window.$nuxt.$config.FAKE_DOMAIN_ENABLED
          : process.env.FAKE_DOMAIN_ENABLED
        : false;
    },
  },
});
</script>
<style lang="scss">
.headline-labels {
  &__label {
    margin-top: 8px;
    font-family: get-font-family('system');
    font-size: 10px;
    font-weight: get-font-weight('semi-bold');
    color: get-color('link-1');
    text-transform: uppercase;
  }

  &__label--paid {
    display: inline-flex;
  }

  &__label--pill {
    padding: 2px 8px;
    border-radius: $base-radius;
    background: get-color('link-1');
    color: get-color('white');
    font-weight: normal;
  }

  &__item-wrapper {
    margin: 0 -5px;
  }

  &__item {
    padding: 0 5px;
  }

  .paid-label__icon {
    margin-top: -3px;
    margin-right: 5px;

    svg {
      height: 15px;
    }
  }

  .headline-category,
  .headline-channel {
    margin: 0;
  }
}
</style>
